import { render } from "./InfiniteScroll.vue?vue&type=template&id=1c7b1f63&scoped=true"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js"

import "./InfiniteScroll.vue?vue&type=style&index=0&id=1c7b1f63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7b1f63"]])

export default __exports__